import { toast } from "react-toastify";
import { requestBackendReportExport } from "./backendReportExport";

export const TARGETING_REPORT_TYPE = "TARGETING";

export function buildTargetingExportQueryBody({
  orderBy,
  sortingOrder,
  durationOneStartDate,
  durationOneEndDate,
  durationTwoStartDate,
  durationTwoEndDate,
  masterRow = false,
  filtering = [],
}) {
  return {
    order_by: orderBy,
    sorting_order: sortingOrder,
    duration_one_start_date: durationOneStartDate,
    duration_one_end_date: durationOneEndDate,
    duration_two_start_date: durationTwoStartDate,
    duration_two_end_date: durationTwoEndDate,
    master_row: masterRow,
    filtering,
  };
}

export function getOptimizerVisibleColumnKeys(visibleHeaders = []) {
  return visibleHeaders.map((header) => header?.key).filter(Boolean);
}

export async function exportOptimizerReport({
  clientId,
  userPlatform = "amazon",
  triggeredBy,
  totalCount,
  queryBody,
  visibleColumnKeys,
  metricView = "aggregate",
  isComparison = false,
  setIsExporting = () => {},
  onExportSuccess = () => {},
}) {
  try {
    setIsExporting(true);

    await requestBackendReportExport({
      clientId,
      userPlatform,
      reportType: TARGETING_REPORT_TYPE,
      totalCount,
      triggeredBy,
      queryBody,
      frontendConfig: {
        metric_view: metricView,
        include_summary_row: true,
        is_comparison: isComparison,
        columns: visibleColumnKeys,
      },
    });

    onExportSuccess();
  } catch (error) {
    console.error(error);
    toast.error(
      error?.response?.data?.message ?? "Failed to submit export request."
    );
  } finally {
    setIsExporting(false);
  }
}
